import { inject } from 'aurelia-framework';
import { DialogController } from 'aurelia-dialog';

@inject(DialogController)
export class Confirm {
    constructor(controller) {
        this.controller = controller;
    }

    activate(model) {
        this.message = model?.message;
        if (this.message == null) {
            this.message = 'You won\'t be able to revert this!';
        }
    }
}